import { queryClient } from "@/services/react-query/queryClient";
import { stripePromise } from "@/services/stripe/initStripe";
import { AuthProvider } from "@/services/supabase/auth/AuthContext/AuthContext";
import { ChakraProvider } from "@chakra-ui/react";
import { theme } from "@pufflig/prompt-studio-ui";
import { Elements as StripeProvider } from "@stripe/react-stripe-js";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";
import { AppRoutes } from "./AppRoutes";
import { MobileUnsupportedOverlay } from "./features/Navigation/components/MobileUnsupportedOverlay";

export function App() {
  return (
    <StripeProvider stripe={stripePromise}>
      <PostHogProvider client={posthog}>
        <ChakraProvider theme={theme}>
          <QueryClientProvider client={queryClient}>
            <AuthProvider>
              <AppRoutes />
              <MobileUnsupportedOverlay />
            </AuthProvider>
            <ReactQueryDevtools initialIsOpen={false} />
          </QueryClientProvider>
        </ChakraProvider>
      </PostHogProvider>
    </StripeProvider>
  );
}
